import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import client, { resolveMedia } from "../lib/api";

export default function StoryViewer() {
  const { id } = useParams();
  const [stories, setStories] = useState([]);
  const [idx, setIdx] = useState(0);
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    client.get("/videos/stories").then((r) => {
      setStories(r.data);
      const i = r.data.findIndex((s) => s.id === id);
      setIdx(i >= 0 ? i : 0);
    });
  }, [id]);

  useEffect(() => {
    if (stories.length === 0) return;
    setProgress(0);
    const dur = 7000;
    const start = Date.now();
    const t = setInterval(() => {
      const p = Math.min(100, ((Date.now() - start) / dur) * 100);
      setProgress(p);
      if (p >= 100) {
        clearInterval(t);
        if (idx + 1 < stories.length) navigate(`/story/${stories[idx + 1].id}`);
        else navigate("/");
      }
    }, 50);
    return () => clearInterval(t);
  }, [idx, stories, navigate]);

  if (stories.length === 0) return <div className="h-screen flex items-center justify-center text-zinc-500" data-testid="story-empty">No stories.</div>;
  const s = stories[idx];
  if (!s) return null;
  const isVideo = s.playback_url && (/\.mp4|\.webm|\.mov/i.test(s.playback_url) || s.source_type === "upload");

  return (
    <div data-testid="story-viewer" className="fixed inset-0 z-50 bg-black flex items-center justify-center" onClick={() => navigate("/")}>
      <div className="absolute top-4 left-4 right-4 flex gap-1 z-10">
        {stories.map((_, i) => (
          <div key={i} className="flex-1 h-0.5 bg-white/20 overflow-hidden rounded-full">
            <div className="h-full bg-[#FF6B00]" style={{ width: i < idx ? "100%" : i === idx ? `${progress}%` : "0%" }} />
          </div>
        ))}
      </div>
      <div className="absolute top-8 left-4 right-4 flex items-center gap-3 z-10 mt-2">
        <span className="text-[10px] uppercase tracking-[0.3em] text-[#FFB800] font-bold">Story · {s.category}</span>
        <span className="text-sm text-white font-bold">{s.title}</span>
      </div>

      <div className="relative w-full max-w-md aspect-[9/16] bg-zinc-900 rounded-xl overflow-hidden">
        {isVideo ? (
          <video src={resolveMedia(s.playback_url)} autoPlay muted playsInline className="w-full h-full object-cover" />
        ) : (
          <img src={resolveMedia(s.thumbnail) || resolveMedia(s.playback_url)} alt={s.title} className="w-full h-full object-cover" />
        )}
      </div>
    </div>
  );
}
